// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"ad1749e6","94":"706c68aa","153":"a9972735","251":"caed30d6","352":"f63907f4","453":"584f3bd4","503":"e55e784e","563":"a56656a6","591":"406d999e","625":"6ffa4314","727":"3a07c1c7","814":"f402173c","818":"e7194e2c","931":"2c6dab24"}[chunkId] + ".chunk.js";
};